module.exports = __webpack_public_path__ + "static/media/doodle_coins.689a3f1e.png";